// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"698cb400","423":"786c88fa","713":"c8ec5094","854":"1760044e"}[chunkId] + ".chunk.js";
};